import { Container, Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";

import FormikControl from "../../../util/formcomponents/FormikControl";
import TextError from "../../../util/formcomponents/TextError";
import PrimaryButton from "../../../util/Btns/PrimaryButton";

import "./NewProjectModalv2.styles.scss";
import logo from "../../../Assets/project-icon.svg";
import info from "../../../Assets/info.svg";
import Close from "../../../Assets/close.svg";

import ConsoleLocalStorage from "../../../storage/storage";
import { useCreateProject } from "../../../hooks/DevProjectHooks";
import { useGetCategoryList } from "../../../hooks/DevAppHooks";
import { Tooltip } from "@material-ui/core";
import DEAModal from "./DEAModal";
import AuthImage from "../../../components/common/AuthImage";
import { useEffect } from "react";
import { isProxyUrl } from "../../../util/imageUtils";

const appType = [
  {
    key: "Build an application from scratch",
    value: "Build an application from scratch",
  },
  {
    key: "Port my existing AR/VR Application on JioGlass",
    value: "Port my existing AR/VR Application on JioGlass",
  },
];

const engineOptions = [
  { key: "Unity", value: "Unity" },
  { key: "Unreal", value: "Unreal" },
];
const platformOptions = [
  { key: "Oculus Go", value: "Oculus Go" },
  { key: "Oculus Quest", value: "Oculus Quest" },
  { key: "HTC Vive", value: "HTC Vive" },
  { key: "Magic leap", value: "Magic leap" },
  { key: "Microsoft Hololens", value: "Microsoft Hololens" },
  { key: "Google Daydream", value: "Google Daydream" },
  { key: "Nreal", value: "Nreal" },
  { key: "PS VR", value: "PS VR" },
  {
    key: "Mobile AR (AR Core/ AR Kit)",
    value: "Mobile AR (AR Core/ AR Kit)",
  },
  { key: "Samsung Gear VR", value: "Samsung Gear VR" },
  { key: "Other", value: "Other" },
];
const developerKitOptions = [
  { key: "2", value: "2" },
  { key: "4", value: "4" },
  { key: "6", value: "6" },
  { key: "Other", value: "" },
];

const validationSchema = Yup.object().shape(
  {
    name: Yup.string().min(3,'Minimum 3 characters required')
      .required("Required")
      .matches(/^([A-Za-z0-9 ]*[A-Za-z]){3,}[A-Za-z0-9 ]*$/, "Enter valid name"),
    appType: Yup.string().required("Required"),
    category: Yup.string().required("Required"),
    dust:Yup.string().matches(/^[1-9][0-9]*$/,"Must be greater than 0"),
    engine: Yup.array().when("publishedPlatform", {
      is: (publishedPlatform) =>
        !publishedPlatform || publishedPlatform.length === 0,
      then: Yup.array().min(1,"Required").required("Required"),
    }),
    publishedPlatform: Yup.array().when("engine", {
      is: (engine) => !engine || engine.length === 0,
      then: Yup.array().min(1,"Required").required("Required"),
    }),
    appConcept: Yup.string().min(20,'Minimum 20 characters required').required("Required"),
    alphaReleaseDate: Yup.date().required("Required"),
    mediaLink: Yup.string().min(4,'Minimum 4 characters required').matches(
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
      "Enter valid link"
    ),
    betaReleaseDate: Yup.date()
      .when(
        "alphaReleaseDate",
        (alphaReleaseDate, schema) =>
          alphaReleaseDate &&
          schema.min(alphaReleaseDate, "Must be after Alpha Release Date")
      )
      .required("Required"),
    prodReleaseDate: Yup.date()
      .when(
        "betaReleaseDate",
        (betaReleaseDate, schema) =>
          betaReleaseDate &&
          schema.min(betaReleaseDate, "Must be after Beta Release Date")
      )
      .required("Required"),
    developerKit: Yup.string()
      .matches(/^[1-9][0-9]*$/, "Must be greater than 0")
      .required("Required"),
  },
  ["engine", "publishedPlatform"]
);
const NewProjectModal = ({ showNewProject, setShowNewProject, showDEA, setShowDEA }) => {
  const { mutate, data } = useCreateProject(setShowNewProject, setShowDEA);
  const { data: categoryOptions } = useGetCategoryList("project");

  useEffect(() => {
    if (!Array.isArray(categoryOptions) || categoryOptions.length === 0) return;

    const sample = categoryOptions.slice(0, 5).map((option) => ({
      name: option?.name,
      devIcon: option?.devIcon,
      isProxy: isProxyUrl(option?.devIcon),
    }));

  }, [categoryOptions]);

  const onSubmit = (values) => {
    var val = Object.assign({},values);
    var index = val.publishedPlatform.indexOf("Other");
    if(index>-1){
      val.publishedPlatform.splice(index,1);
      val.publishedPlatform.push(val.platformOther);
      delete val.platformOther;
    }
    val.tags = ConsoleLocalStorage.getOrganization().tags || "consumer";
    val.publishedPlatform = val.publishedPlatform.toString();
    mutate(val);
  };

  const initialValues = {
    name: "",
    category: "",
    appType: "Build an application from scratch",
    publisherName: ConsoleLocalStorage.getOrganization().publisherName,
    publishedPlatform: [],
    engine: [],
    appConcept: "",
    mediaLink: "",
    dust: "",
    alphaReleaseDate: "",
    betaReleaseDate: "",
    prodReleaseDate: "",
    developerKit: "2",
    platformOther:""
  };

  return (
    <>
    {data?.id && <DEAModal
        showDEA={showDEA}
        projectid={data.id}
        setShowDEA={setShowDEA}
      />}
      
      <Container>
        <Modal
          show={showNewProject}
          onHide={() => setShowNewProject(false)}
          contentClassName={"new_project"}
          dialogClassName="mah_modal"
        >
          <Modal.Header className="title_modal_header">
            <Modal.Title>
              <div>
                <img
                  src={logo}
                  alt="logo"
                  className="fluid logo console_card_img"
                  style={{ marginRight: "0.25em" }}
                />
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Create New Project
                </span>
              </div>
            </Modal.Title>
            <img
              onClick={() => setShowNewProject(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              validateOnChange
            >
              {(formik) => {
                // console.log(formik);
                return (
                  <Form>
                    <div className="new_project_body">
                      <FormikControl
                        control="input"
                        type="text"
                        label="Project Name"
                        name="name"
                        maxLen="30"
                      />
                      <FormikControl
                        control="radio"
                        required
                        options={appType}
                        label="What would you like to do?"
                        name="appType"
                      />

                      <label className="xs-lable-select white" required>
                        Which Appstore category does your application belong to?
                        <span style={{ color: "red" }}>{` *`}</span>
                      </label>
                      <div className="category_list">
                      {categoryOptions && <Field name={"category"}>
                          {({ field: { value }, form: { setFieldValue } }) => {
                            return (
                              categoryOptions &&
                              categoryOptions.map((option) => {
                                return (
                                  <div
                                    className="category_container"
                                    key={option.name}>
                                    <div
                                      className={`category_box ${
                                        formik.values.category === option.id
                                          ? "category_box_active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        setFieldValue("category", option.id)
                                      }
                                    >
                                      <AuthImage
                                        style={{ width: "20px" }}
                                        src={option.devIcon}
                                        alt="category-icon"
                                      />
                                    </div>
                                    <span
                                      className={`category_title ${
                                        formik.values.category === option.id
                                          ? "category_title_active"
                                          : ""
                                      }`}
                                    >
                                      {option.name}
                                    </span>
                                  </div>
                                );
                              })
                            );
                          }}
                        </Field>}

                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className=""></div>
                          <ErrorMessage
                            component={TextError}
                            name={"category"}
                          />
                        </div>
                      </div>

                      <div className="project_publisher_label_container">
                        <label
                          htmlFor={"publisherName"}
                          className="xs-lable-select white project_publisher_label"
                        >
                          Publisher's name
                        </label>
                        <Tooltip
                          title="To change your publisher's name contact admin"
                          arrow
                        >
                          <p className="publisher_i_btn">
                            <img
                              data-class="myTooltipClass"
                              src={info}
                              alt="category-icon"
                            />
                          </p>
                        </Tooltip>
                      </div>

                      <div className="primary_input">
                        <Field>
                          {({ field }) => {
                            // console.log(field);
                            return (
                              <input
                                id={"publisherName"}
                                name="publisherName"
                                value={field.value.publisherName}
                                style={{ color: "#646464" }}
                                disabled
                              />
                            );
                          }}
                        </Field>
                      </div>

                      {formik.values.appType ===
                      "Build an application from scratch" ? (
                        <FormikControl
                          control="checkbox"
                          name="engine"
                          options={engineOptions}
                          label="Which game engine do you develop on?"
                        />
                      ) : (
                        <FormikControl
                          control="checkbox"
                          options={platformOptions}
                          label="What platform is your application already published on?"
                          name="publishedPlatform"
                          other="platformOther"
                          present={platformOptions.map((opt) =>
                            opt.key !== "Other" ? opt.value : null
                          )}
                        />
                      )}

                      <label className="xs-lable-select white" required>
                        Describe your application concept:
                        <span style={{ color: "red" }}>{` *`}</span>
                      </label>
                      <FormikControl
                        maxLen="2000"
                        rows="6"
                        autoComplete="nope"
                        control="textarea"
                        sublabel="Please mention your app/game concept, storyline, feature, target audience, development timelines."
                        name="appConcept"
                      />

                      <FormikControl
                        control="input"
                        required={false}
                        type="text"
                        label="Please insert reference media links to better describe your concept(APK links/demo video links)"
                        name="mediaLink"
                        maxLen="260"
                      />
                      <FormikControl
                        control="input"
                        required={false}
                        type="tel"
                        label="How much time is estimated for a user to spend on your application daily?(In Minutes)"
                        name="dust"
                        maxLen="3"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />

                      <FormikControl
                        control="date"
                        label="Please mention your estimated Alpha Release date"
                        name="alphaReleaseDate"
                        minDate={new Date()}
                      />
                      <FormikControl
                        control="date"
                        label="Please mention your estimated Beta Release date"
                        name="betaReleaseDate"
                        minDate={new Date()}
                      />
                      <FormikControl
                        control="date"
                        label="Please mention your estimated Production Release date"
                        name="prodReleaseDate"
                        minDate={new Date()}
                      />
                      <FormikControl
                        control="radio"
                        options={developerKitOptions}
                        label="How many developers would you need?"
                        name="developerKit"
                        present={["2", "4", "6"]}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "1em",
                      }}
                    >
                      <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default NewProjectModal;
